import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { NavigationRoutes } from '../../application/router/routes';

const DashboardView = () => {
    const navigate = useNavigate();

    useEffect(() => {
        navigate(NavigationRoutes.transaction);
    }, []);

    return null;
};

export default DashboardView;
